module.exports = "/images/first-time-homebuyer.png?e0f6b543ce87d0ac0b5f6c0dd7fc391a";